import { createContext, useContext, useState } from "react";

const GetInvolvedModalContext = createContext(null);

export function GetInvolvedModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <GetInvolvedModalContext.Provider value={{ isOpen, openModal, closeModal }}>
      {children}
    </GetInvolvedModalContext.Provider>
  );
}

export function useGetInvolvedModal() {
  return useContext(GetInvolvedModalContext);
}
